/** @jsx builderX.jsx */

import { builderX, Sprite, Image } from '@gongxigames/framework/core/fragments/BuilderX';

export default (
    <Sprite name='resources'>
        <Image src='swipe_icon' />
    </Sprite>
);
